import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 任务类型枚举
 */
class TaskType extends UltMeta {
    EXPORT = new Meta("EXPORT", "导出");
    PRINT = new Meta("PRINT", "打印");
    REPORT_PACKAGE = new Meta("REPORT_PACKAGE", "报表打包");
    DOWNLOAD = new Meta("DOWNLOAD", "下载");
    IMPORT = new Meta("IMPORT", "导入");
}
export const TASK_TYPE = new TaskType();

/**
 * 任务完成状态枚举
 */
class TaskStatus extends UltMeta {
    NOT_COMPLETED = new Meta(0, "未完成");
    COMPLETED = new Meta(1, "已完成");
    FAILED = new Meta(2, "失败");
}
export const TASK_STATUS = new TaskStatus();
